import { useDeviceTimeSeriesLabels, useDeviceTimeSeriesDatasets } from './useDeviceTimeSeriesData';
import { useDeviceTimeSeriesOptions } from './useDeviceTimeSeriesOptions';

/**
 * @param {object} props
 * @param {object[]} props.data
 * @param {object[]} props.datasets
 * @param {object[]} props.scales
 * @param {object[]} [props.actionAnnotations]
 * @param {object[]} [props.userAnnotations]
 * @param {boolean} [props.enabledZoom=false]
 * @param {boolean} [props.enabledMarker=false]
 * @param {boolean} [props.displayAxisTitle=false]
 * @param {boolean} [props.displayActionAnnotation=false]
 * @param {boolean} [props.displayUserAnnotation=false]
 * @param {boolean} [props.displayDataLabel=false]
 * @param {boolean} [props.displayMarker=false]
 * @param {*} [props.onMarkerHover]
 * @param {*} [props.onMarkerAdd]
 * @param {*} [props.onMarkerChange]
 * @param {*} [props.onZoomComplete]
 * @param {*} [props.onResize]
 */
function useDeviceTimeSeriesChart(props) {
  const labels = useDeviceTimeSeriesLabels(props);
  const datasets = useDeviceTimeSeriesDatasets(props);
  const options = useDeviceTimeSeriesOptions(props);

  return {
    type: 'line',
    data: {
      labels,
      datasets
    },
    options
  };
}

export { useDeviceTimeSeriesChart };
